module.exports = __webpack_public_path__ + "img/0Q3A2496_P_L_Foamcore_MockedUp.b4d4f3a7.jpg";